import { useEffect, useRef, useState } from 'react';

export const useIsTruncated = <T extends HTMLElement>() => {
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const checkTruncation = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    checkTruncation();

    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, []);

  return { ref, isTruncated };
};
